<div id="dialog-create-ttd-partner">
  <button mat-icon-button
          id="button-dialog-close"
          class="mat-icon-button-small"
          data-cy="button-dialog-close"
          [mat-dialog-close]="true">
    <mat-icon>clear</mat-icon>
  </button>
  <h1 mat-dialog-title>New The Trade Desk Partner</h1>

  <div mat-dialog-content class="mat-body-1">
    <p>Create a new 'The Trade Desk' Partner.</p>
    <mat-error *ngIf="errorMessage">{{errorMessage}}</mat-error>
    <form>
      <mat-form-field>
        <mat-label>Partner name</mat-label>
        <input matInput [formControl]="partnerName" required
               placeholder="Partner name">
        <mat-error *ngIf="partnerName.invalid">{{getErrorMessage()}}</mat-error>
      </mat-form-field>
      <br>
      <mat-form-field>
        <mat-label>Partner Id</mat-label>
        <input matInput
               [formControl]="partnerId"
               placeholder="Partner id">
        <mat-error *ngIf="partnerId.invalid">{{getErrorMessage()}}</mat-error>
      </mat-form-field>
    </form>
  </div>

  <div mat-dialog-actions>
    <button mat-button id="btn-reset-ttd-partner" (click)="reset()">Reset</button>
    <button mat-button [disabled]="partnerName.invalid || partnerId.invalid" id="btn-create-ttd-partner"
            (click)="create()">Create
    </button>
  </div>
</div>
